import './index.scss';
import AnimatedLetters from '../AnimatedLetters'
import {useState, useEffect} from 'react';
import Loader from 'react-loaders'

import MITLab from '../../assets/images/MIT Lab.png'
import thaparUni from '../../assets/images/thaparUni.jpg'
import peraton from '../../assets/images/peraton.jpg'
import virginiaTech from '../../assets/images/virginiaTech.jpg'
import concentrix from '../../assets/images/concentrix.png'
import face from '../../assets/images/rohanLeekha.jpg'

const About=()=>{
    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 2500)
      }, [])

    return (
        <div>
            <div className = 'container about-page'> 
                <div className = 'text-zone'> 
                    
                    <h1> 
                        <AnimatedLetters 
                        letterClass={letterClass}
                            strArray={['A','b','o','u','t',' ','M','e']}
                            idx = {15} 
                        />
                    </h1>
                    <p>Hi there, I am a graduate student at Virginia Tech. So, you can usually find me in the Graduate Life Centre at VT, Blacksburg. </p>
                    <p>
                        I am currently pursuing an M.S. in Computer Science and Applications (Batch 2023) under my advisor Dr. Eugenia Rho. We are part of the Society + AI &amp; Language Lab (SAIL) where we examine subjects ranging from social interactions in police discourse to online discussions around current events using deep multimodal learning such as speech, vision, and text!            </p>

                    <p>
                        Previously I worked at Concentrix as a Lead Application Development Engineer - Machine Learning to build scalable machine learning services. Over my three years there, I focused on tackling various relevant business problems, for instance, building large-scale home agent monitoring systems, speech recognition models, and a friendship recommendation system using collaborative filtering.            
                    </p>

                    <p>
                        I received my B.E in Computer Science from Thapar University in 2019, where I worked with Dr. Vinay Arora on Biomedical Signal Processing, Machine Learning, Fraud Detection, and Intrusion Detection. 
                    </p>

                    <p>
                        Through my consistent perseverance, I have been a co-author of seven research papers published in top SCI ranked journals and co-inventor of two Australian Innovation Patents. In addition, since 2019, I have been a reviewer in the Journal of Computers in Biology and Medicine.
                    </p>
                </div>

                <div className="stage-cube-cont">
                    <div className = 'cubespinner'>

                        <div className = 'face1'>
                            <a href = 'https://www.thapar.edu'>
                                <img src = {thaparUni} alt="thapar"/>
                            </a>
                        </div>

                        <div className = 'face2'>
                            <a href='https://www.concentrix.com'>
                                <img src = {concentrix} alt="concentrix - job"/>
                            </a>
                        </div>

                        <div className = 'face3'>
                            <img src = {face} alt="my face"/>
                        </div>
                        <div className = 'face4'>
                            <a href ='https://vt.edu'>
                                <img src = {virginiaTech} alt="VT"/>

                            </a>
                        </div>
                        <div className = 'face5'>
                            <a href = 'https://www.peraton.com'>
                                <img src = {peraton} alt="peraton -internship"/>
                            </a>
                        </div>
                        <div className = 'face6'>
                            <a href = 'https://www.ll.mit.edu'>
                                <img src = {MITLab} alt="MIT - intern"/>
                            </a>
                        </div>

                    </div>
                </div>
            </div>

            <Loader type="pacman"/>
        </div> 
    )
};

export default About; 